import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import SalesByProductForm from "@components/dynamic/SalesByProductForm";

const SalesByProductReport = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Reporte de Historial de Ventas"
      backUrl="/user/dashboard-inventory"
    >
      <SalesByProductForm />
    </PageContainer >
  );
}

export default SalesByProductReport;
